





























































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, maxValue } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../_store';
import { STORE_KEY, store } from './_store';
import Attachments from '@/components/Controls/Attachments.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'relatedFactsList'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'storages'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    console.log('123')
    const rules: any = {
      vdp_plan_id: { required },
      quantity: {required},
      weight: {required},
    }

    return {
      form: rules
    }
  },
  components: {
    Attachments
  }
})
export default class ShiftAtomCoockPlanItemForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;
  @Prop({ type: String }) filter_base_id!: any;

  document!: any
  form!: any
  relatedFactsList!: any

  logo_id: number|null = null;
  group: number|null = null;
  base_id: string|null = null
  plan_row: any = {};

  groups: any[] = [
    {id: 'm', label: 'M'},
    {id: 't', label: 'T'},
    {id: 'm+t', label: 'M+T'},
  ]

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];
  public rotates: any[] = [];
  public activity_id: any = null;
  public mark: any = {
    mark_no_incident: null,
    mark_water_state: null,
    mark_no_fat: null,
    mark_normal_acidity: null,
  };

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });
  }

  addItem(storage_id: any) {
    this.$store.dispatch(`${STORE_KEY}/addItem`, {storage_id});
  }

  removeItem(index: any) {
    this.$store.dispatch(`${STORE_KEY}/removeItem`, index);
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, {newValue: file});
  }

  changeStorageValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeStorageValue`, {
      index, field, newValue: value
    });
  }

  setBase($event: any) {
    if ($event && $event.label) {
      this.changeValue('base_id', $event.base_id)
      this.changeValue('base_product_date', $event.date)
    }
  }

  setVdp($event: any) {
    console.log($event)
    if ($event) {
      this.changeValue('base_id', $event.base_id)
      this.changeValue('mark', {
        mark_no_incident: $event.mark_no_incident,
        mark_water_state: $event.mark_water_state,
        mark_no_fat: $event.mark_no_fat,
        mark_normal_acidity: $event.mark_normal_acidity,
      })
      this.changeValue('comment', $event.comment)
      this.changeValue('remains', parseFloat($event.volume_filled) - parseFloat($event.volume_out));

      this.plan_row = $event
      if ($event.volume_type == 'tank'){
        this.changeValue('quantity', '1')
      }
    }
  }

  onStarterTypeChange($event: any) {
    console.log($event)
    if ($event && $event.label) {
      this.form.activity_id = $event.activity_id;
      console.log($event)
      this.rotates = $event.rotate_ids
    }
  }

  prefilterStarterTypes(item: any, index: number) {
    console.log(item.starter_type, this.form.starter_type)
    return item.starter_type == this.form.starter_type;
  }

  prefilterRotates(item: any, index: number) {
    console.log(this.rotates, item.id)
    return this.rotates.includes(item.id);
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

